'use strict';
var React = require('react');
var Tree = require('./Tree');
var envHelper = require('../helper/envHelper');

var MobilePreviewPanel = React.createClass({
  propTypes: {
    app: React.PropTypes.object,
    current: React.PropTypes.object,
    showPanel: React.PropTypes.bool.isRequired,
    onOpenPage: React.PropTypes.func.isRequired
  },
  getInitialState: function() {
      var queryHeight = location.search;
      var statusBarHeight = 30;  //默认边距
      var isWxMiniApp = false;
      if(envHelper.isWxMiniApp()) {  //是微信小程序环境
          isWxMiniApp = true;
          if(queryHeight.length > 1) {  //高度未初始化且小程序传递了手机状态栏的高度
              queryHeight.substr(1).split('&').forEach(function(item) {
                  var queryItemArr = item.split('=');
                  if(queryItemArr[0] === 'statusbarheight') {
                      statusBarHeight = queryItemArr[1];            //设置状态栏上边距
                  }
              });
          }
      }
      return {
          isWxMiniApp: isWxMiniApp,
          statusBarHeight: statusBarHeight
      };
  },
  render: function () {
    var app = this.props.app;
    var style = {
        paddingTop: this.state.statusBarHeight,
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 10
    };
    if (this.props.showPanel) {
      style.marginLeft = 0;
    } else {
      style.marginLeft = -200;
    }

    var modules = this.filterHiddenPage();
    return (
      <div className="mobile-preview-panel preview-panel" style={style}>
         <div className="mobile-panel-wrap">
             <div className="header">
                 <h1>{app.name}</h1>
             </div>
            <div className="pages" style={{bottom: this.state.isWxMiniApp ? '50px' : 0}}>
              <Tree
                name={this.props.app.name}
                current={this.props.current}
                modules={modules}
                onSelectPage={this.props.onOpenPage}/>
            </div>
             {
                 this.state.isWxMiniApp &&
                 <button className="back-btn" onClick={this.miniProgramGoBack}>返&nbsp;回</button>
             }
         </div>
      </div>
    );
  },
  // 返回小程序
  miniProgramGoBack: function() {
      wx.miniProgram.navigateBack();
  },
  filterHiddenPage: function() {
    var isShowTitleIndex = this.props.app.params.projectParam.isShowTitleIndex;
    var isShowAllPageNode = this.props.isShowAllPageNode;     //是否显示所有隐藏页面
    var modules = JSON.parse(JSON.stringify(this.props.app.modules));

    var filter = function(pages, preIndex) {
      var count = 0;
      var page;
      var index;

      for(var i=pages.length-1;i>=0;i--) {
        var childs = 0;
        page = pages[i];
        if(page.isshownode === undefined) {     //兼容旧版本
          return this.props.app.modules;
        }
        if(!page.isshownode && !isShowAllPageNode) {
          pages.splice(i, 1);
        } else {
          if(isShowTitleIndex) {
            index = preIndex ? preIndex+'.'+(i+1) : (i+1)+'';
            page.name = index + ' ' + page.name;
          }
          if(page._pages && page._pages.length > 0) {
            childs = filter(page._pages, index);
            count += childs;
          }
          if(page.isModule) {
            page.childCount = childs;
          } else {
            count++;
          }
        }
      }
      return count;
    };

    if(isShowTitleIndex !== undefined) {    //兼容旧版本
      modules.childCount = filter(modules._pages);
    }
    return modules;
  }
});

module.exports = MobilePreviewPanel;


// WEBPACK FOOTER //
// ./src/views/MobilePreviewPanel.jsx